import { render, staticRenderFns } from "./SecretPrescriptionMngt.vue?vue&type=template&id=2f60a24b"
import script from "./SecretPrescriptionMngt.vue?vue&type=script&lang=js"
export * from "./SecretPrescriptionMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports